<template>
  <section>
    <!-- <header
      style="position: fixed; top: -15px; padding: 15px 15px 0px 15px; left: 0; border-bottom: 1px solid #AB4FF4; width: 100% !important; background: white; z-index: 1;"
    >
      <h2 class="purple-text">Unthink Summer Party Night</h2>
    </header> -->
    <form @submit.prevent="submitGameCode()">
      <section class="cont-fullwidth" style="overflow: hidden !important;">
        <div class="row d-flex align-content-center">
          <div
            class="col-12 d-flex align-items-center justify-content-center"
            style=" padding-top: 30px; padding-bottom: 90px;"
          >
            <div class="innerpadding-30 w-600">
              <h2 class="blue-text onboard mb-1 space-grot-reg">Enter game code</h2>
              <h1 class="space-grot-bold mt-0 mb-1 onboard">
                Do you have<br />your code handy?
              </h1>
              <input
                v-model="code"
                type="text"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                class="form-item-login mb-2"
                placeholder="Enter your code here"
                aria-label="Answer here"
                autofocus
              />
              <div v-if="message">{{ message }}</div>
            </div>
          </div>
        </div>
      </section>

      <nav
        style="position: fixed; text-align: center; bottom: -10px; padding: 15px 15px 0px 15px; left: 0; border-top: 0px solid #AB4FF4; width: 100% !important; background: white; z-index: 1;"
      >
        <button class="btn-blue-form mb-2 w-600" type="submit">Submit</button>
      </nav>
    </form>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  components: {},
  props: [],
  mounted() {
    document.body.classList.add('onboarding')
  },
  data: () => ({
    code: '',
    message: '',
    valid: false
  }),
  computed: {
    ...mapState({
      game: state => state.game
    }),
    gameData() {
      return this.game.game?.gameData
    }
  },
  methods: {
    ...mapActions('game', ['fetchGame']),
    submitGameCode() {
      this.fetchGame({ code: this.code })
        .then(response => {
          console.log('🦟 response.status: ' + response.status)

          console.log('game code is valid')

          this.$router.push({
            name: 'create-team',
            params: { code: this.code }
          })
        })
        .catch(error => {
          console.log('There was a problem loading the game: ' + error.message)

          this.message = 'Enter a valid game code.'
        })
    }
  }
}
</script>
